<template>
  <div>
    <el-form-item
      v-for="(item, index) in filteredProperties"
      v-show="((item.onlyEdit && isEdit) || !item.onlyEdit) && !item.hidden"
      :key="index"
      :label="label(item)"
      :prop="item.names"
    >
      <div v-if="item.format === 'cascader'">
        <Cascader v-model="form[item.names]" :data="item.items" />
      </div>
      <div v-else-if="item.format === 'date'">
        <el-date-picker
          v-model="form[item.names]"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        />
      </div>
      <div v-else-if="item.format === 'time'">
        <el-time-picker
          v-model="form[item.names]"
          type="time"
          value-format="HH:mm"
          :picker-options="pickerOptions"
        />
      </div>
      <div v-else-if="item.format === 'date-time'">
        <DateTimePicker v-model="form[item.names]" type="datetime" />
      </div>
      <div v-else-if="item.type === 'boolean'">
        <el-switch
          v-model="form[item.names]"
          :disabled="form[item.disabled_if]"
          @change="handleSwitchChange($event, item)"
        />
      </div>
      <div v-else-if="item.type === 'integer'">
        <InputNumber
          v-model="form[item.names]"
          :max-length="item.maxLength"
          :disabled="form[item.disabled_if]"
          :placeholder="item.placeholder"
        />
      </div>
      <div v-else-if="item.type === 'percent'">
        <el-input-number
          v-model="form[item.names]"
          :min="item.minimum"
          :max="item.maximum"
          :disabled="form[item.disabled_if]"
        />
      </div>
      <div v-else-if="item.type === 'array' && item.name === 'selectInTable'">
        <SelectInTable
          v-model="form[item.names]"
          :data="item.items"
          :columns="item.columns"
          :select="item.select"
        />
      </div>
      <div v-else-if="item.type === 'array' || item.format === 'uuid'">
        <CmpSelect
          v-if="item.params"
          v-model="form[item.names]"
          :data="item.items"
          :params="item.params"
          :readonly="item.isEditWhenReadOnly && isEdit"
        />
      </div>
      <div v-else-if="item.type === 'popup'">
        <SelectPopup
          v-if="item.params"
          v-model="form[item.names]"
          :data="item.items"
          :params="item.params"
          :readonly="item.isEditWhenReadOnly && isEdit"
        />
      </div>
      <div v-else-if="item.format === 'select'">
        <CmpSelectSimple
          v-model="form[item.names]"
          :data="form[item.names]"
          :current="form[item.key]"
          @selected="form[item.key] = +$event"
        />
      </div>
      <div v-else-if="item.format === 'imageAny'">
        <ImageUploadOrField
          v-model="form[item.names]"
          :type="item.image_type"
          :timestamp="item.timestamp"
          :rec-width="item.rec_width"
          :rec-height="item.rec_height"
        />
      </div>
      <div v-else-if="item.format === 'image'">
        <ImageUpload
          v-model="form[item.names]"
          :type="item.image_type"
          :timestamp="item.timestamp"
          :rec-width="item.rec_width"
          :rec-height="item.rec_height"
        />
      </div>
      <div v-else-if="item.format === 'html'">
        <Wysiwyg v-model="form[item.names]" :max-length="item.maxLength" />
      </div>
      <div v-else-if="item.format === 'htmlSupplierOffer'">
        <SupplierTemplate
          v-model="form[item.names]"
          :title="form['title']"
          :banner="form['banner']"
        />
      </div>
      <div v-else-if="item.type === 'color' || item.format === 'color'">
        <ColorPicker v-model="form[item.names]" />
      </div>
      <div v-else-if="item.type === 'arrayToString'">
        <ArrayToString v-model="form[item.names]" />
      </div>
      <div v-else-if="item.type === 'selectString'">
        <SelectString
          v-model="form[item.names]"
          :items="item.select.enum"
          :name="item.select.alias || item.select.names"
          :default-select="item.select.default"
          :default-value="item.default"
          :select-holder="item.select.placeholder"
        />
      </div>
      <div v-else-if="item.enum">
        <Enum
          v-model="form[item.names]"
          :items="item.enum"
          :name="item.alias || item.names"
          :default-value="item.default"
          :clearable="item.clearable"
        />
      </div>
      <div v-else-if="item.format === 'textarea'">
        <el-input
          v-model="form[item.names]"
          type="textarea"
          rows="5"
          :maxlength="item.maxLength"
          show-word-limit
        />
      </div>
      <div v-else-if="item.format === 'binary'">
        <UploadFile v-model="form[item.names]" />
      </div>
      <div v-else-if="item.format === 'phone'">
        <Phone v-model="form[item.names]" />
      </div>
      <div v-else-if="item.format === 'password'">
        <el-input
          type="password"
          v-model="form[item.names]"
          :maxlength="item.maxLength"
          :readonly="item.readOnly || (item.isEditWhenReadOnly && isEdit)"
          show-word-limit
          :placeholder="item.placeholder"
        />
      </div>

      <div v-else>
        <el-input
          v-model="form[item.names]"
          :maxlength="item.maxLength"
          :readonly="item.readOnly || (item.isEditWhenReadOnly && isEdit)"
          show-word-limit
          :placeholder="item.placeholder"
        />
      </div>
      <!-- {{ item.type }}
      {{ item.format }} -->
      <i v-if="item.description" class="form-description">{{
        item.description
      }}</i>
    </el-form-item>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import ColorPicker from "@/components/FormControlColorPicker";
import Cascader from "@/components/FormControlCascader";
import CmpSelect from "@/components/FormControlSelect";
import CmpSelectSimple from "@/components/FormControlSelectSimple";
import Enum from "@/components/FormControlEnum";
import ImageUpload from "@/components/FormControlUploadImage";
import ImageUploadOrField from "@/components/FormControlFieldOrUploadImage";
import Wysiwyg from "@/components/Wysiwyg";
import SupplierTemplate from "@/components/FormControlSupplierHTMLTemplate";
import DateTimePicker from "@/components/FormControlDatePicker";
import InputNumber from "@/components/FormControlNumber";
import UploadFile from "@/components/FormControlUploadFile";
import Phone from "@/components/FormControlPhone";
import SelectInTable from "@/components/FormControlSelectInTable";
import ArrayToString from "@/components/FormArrayToString";
import SelectString from "@/components/FormControlSelectForString";
import SelectPopup from "@/components/FormControlSelectPopup";

export default {
  directives: {
    mask: AwesomeMask,
  },
  components: {
    Wysiwyg,
    SupplierTemplate,
    ColorPicker,
    Cascader,
    CmpSelect,
    CmpSelectSimple,
    Enum,
    ImageUpload,
    ImageUploadOrField,
    DateTimePicker,
    InputNumber,
    UploadFile,
    Phone,
    SelectInTable,
    ArrayToString,
    SelectString,
    SelectPopup,
  },
  props: {
    scheme: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pickerOptions: {
        firstDayOfWeek: 1,
      },
    };
  },
  computed: {
    filteredProperties() {
      const result = [];
      const { hidden } = this.scheme;

      for (const name in this.scheme.properties) {
        const item = this.scheme.properties[name];

        if (hidden && hidden.includes(name)) {
          item.hidden = true;
        }

        item.names = name;
        result.push(item);
      }

      return result;
    },
  },
  mounted() {},
  methods: {
    handleSwitchChange(e, item) {
      if (item.handlerName) {
        const handlerName = item.handlerName;
        switch (handlerName) {
          case "clearDependenciesOnTrue":
            this.clearDependenciesOnTrue(e, item.dependencies);
            break;
          case "recalculateKidsAgeInArticleFormDependencies":
            this.recalculateKidsAgeInArticleFormDependencies(
              e,
              item.dependencies
            );
            break;
          default:
            break;
        }
      }
    },
    clearDependenciesOnTrue(value, dependencies) {
      if (value === true) {
        dependencies.forEach((el) => {
          this.form[el] = null;
        });
      }
    },
    recalculateKidsAgeInArticleFormDependencies(value, dependencies) {
      if (value === false) {
        dependencies.forEach((el) => {
          this.form[el] = this.form[el] * 12;
        });
      }
      if (value === true) {
        dependencies.forEach((el) => {
          this.form[el] = Math.floor(this.form[el] / 12);
        });
      }
    },
    label(item) {
      if (item.title_alternative && this.form[item.title_alternative_if]) {
        return item.title_alternative;
      }
      return item.title;
    },
  },
};
</script>

<style lang="css" scope>
.form-description {
  opacity: 0.5;
  line-height: 1.4;
  display: block;
  margin-top: 5px;
}
</style>
